import { Component, EventEmitter, Input,  OnInit, Output } from "@angular/core";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../services/admin.service";
import { apiUrl } from "../../global/global";
import { ToastrService } from "ngx-toastr";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { HttpParams } from "@angular/common/http";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, map } from "rxjs/operators";

@Component({
  selector: "app-skills",
  templateUrl: "./skills.component.html",
  styleUrls: ["./skills.component.css"]
})
export class SkillsComponent implements OnInit {
  modalRef?: BsModalRef;
  form: FormGroup;
  showError = false;
  show = true;
  // skillList
  skillList:any=[];  
  allSkills:any=[];  
  userQuestion: string = "";
  userQuestionUpdate = new Subject<string>();
  addedSkills:any=[];
  //step
  isStepper : number = 1;
  isSteps;
  @Input() filledData: any;
  @Output() valueChange = new EventEmitter();
  @Output() stepperChange = new EventEmitter();
  @Output() changeDetected: EventEmitter<any> = new EventEmitter<any>();
  constructor(private modalService: BsModalService,private formBuilder: FormBuilder,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService) {
    this.form = this.formBuilder.group({
      skillIdsArray: ["", Validators.compose([Validators.required])],
    });
   }

  ngOnInit(): void {
    this.userQuestionUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        if(value == ""){
          this.skillList = [];
        } else{
          let params = new HttpParams(); 
        params = params.append("search", value);
        this.api.showLoader=false;
        this.api.loader(false)
        this.api.getData(apiUrl._searchSkills,params)
              .subscribe(async (res) => {
                this.skillList = [];
                res.data.skills.map((skill) => {
                  let alreadyAdded = false;
                  this.addedSkills.map((addedSkills)=> {
                    if (addedSkills.id == skill.id) {
                      alreadyAdded = true;
                    }
                  })
                  if (!alreadyAdded) {
                    this.skillList.push(skill);
                  }
                  this.show=true;
                })
                
          })
        }
        
      });
      this.getSkills();
  } 
  search() {
    this.userQuestionUpdate.next(this.userQuestion)
  }
  drop(){
    // this.show=false;
    this.show = !this.show;
  }
  selectedSkill(i){
    this.addedSkills.push(this.skillList[i])
    this.skillList.splice(i,1) 
    this.show = !this.show;
  }
  removeSkills(i){
    this.addedSkills.splice(i,1)
    this.show = !this.show;
  }
  // get skills
  getSkills(){
    this.api.stopLoader(); 
    this.api.getDatas(apiUrl._getSkill)
    .subscribe(async (res) => {
      res.data.map((skill) => {
        this.addedSkills.push(skill.skillDetails);
      })
    })
  }
  onSubmit(){
    let skillIds:any=[];
    this.addedSkills.map((skill)=>{
      skillIds.push({"skillId":skill.id,"otherTitle":skill.name})
    })
    this.form.patchValue({
      skillIdsArray: skillIds
    })
 
    this.show = !this.show;
    if(this.form.valid && this.addedSkills.length <= 50){
      this.api.putData(apiUrl._updateSkillV1, this.form.value)
      .subscribe(async (res) => {
        this.toastrService.success("", "Skills Added Successfully!");
        this.router.navigate(["/education"]);
      })
    } else{
      // this.toastrService.error("", "You can add up to 10 skills. Please remove additional skills");
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
    
  }

}
